export const initialState = {
  cameraPosition: [-8, 3, 5],
}
